import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({onSubmit, submitting, closeModal, invalid}) => (
  <div className="Buttons colab-row-space-between">
    <Button white onClick={closeModal}>
      Cancel
    </Button>
    <Button
      onClick={onSubmit}
      blue={!submitting}
      isLoading={submitting}
      disabled={submitting || invalid}>
      Add
    </Button>
  </div>
);

export default Buttons;
